<template>
  <v-main class="fullwidth fullheight bg_card" :class="$mq">
    <!-- PC 웹 & 모바일 -->
    <v-card
      flat
      tile
      class="mx-auto"
      min-width="320"
      :max-width="$store.state.web_max_width"
      color="transparent"
    >
      <v-row justify="center" class="title_root">
        <v-col cols="12" class="title_root_text font_black">
          {{ $ml.get("apply_gift_title") }}
        </v-col>
        <div class="title_root_text_line font_black"></div>
        <v-btn
          elevation="0"
          class="title_root_back font_black"
          icon
          v-on:click="$router.go(-1)"
        >
        </v-btn>
      </v-row>

      <v-row v-if="!finish" justify="center" class="main_root">
        <v-card
          width="100%"
          :class="$mq == 'sm' ? 'rounded-b-xl' : 'rounded-b-xl'"
          class="mainCard"
        >
          <v-row justify="center" class="ma-5">
            <v-col
              cols="12"
              class="pa-0 main_title_1_text font_black"
              v-html="title"
            >
            </v-col>
            <v-col class="title_text_sub pa-0">
              <!-- <v-img class="star" src="@/assets/star.png" />
              <span>{{
                $ml.get("apply_gift_title_info_and_sub_title_01")
              }}</span
              ><span class="mx-2 font_white">{{
                $ml.get("apply_gift_title_info_and_sub_title_02")
              }}</span
              ><span>{{
                $ml.get("apply_gift_title_info_and_sub_title_03")
              }}</span> -->
            </v-col>

            <!-- <v-col cols="12" class="main_title_1_text title_text_sub" v-html="title">
            </v-col> -->
          </v-row>

          <v-row justify="center" class="my-0 mx-5 border_dash_bottom">
            <v-img src="@/assets/gift.jpg"></v-img>
          </v-row>

          <v-form ref="form" class="apply_gift_input_root mx-5">
            <v-row class="ma-0 checkBoxPosition">
              <v-checkbox
                class="apply_gift_input checkBox"
                v-model="checkbox"
                :rules="[v => !!v || $ml.get('apply_gift_check_error_1')]"
                :label="$ml.get('apply_gift_check_label')"
                required
              >
              </v-checkbox>
              <div class="open_url">
                <span class="url_position" @click="openURL()">
                  <b
                    ><u>{{ $ml.get("apply_gift_check_label_click") }}</u></b
                  >
                </span>
              </div>
            </v-row>
            <v-row class="ma-0">
              <v-col
                class="pa-0"
                :class="$mq == 'sm' ? '' : 'mr-5'"
                :cols="$mq == 'sm' ? '12' : ''"
              >
                <v-text-field
                  class="apply_gift_input"
                  :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-lg'"
                  solo
                  dense
                  outlined
                  :height="$mq == 'sm' ? '10vw' : 58"
                  :placeholder="$ml.get('apply_gift_name_label')"
                  persistent-hint
                  :value="input_name"
                  :rules="name_rules"
                  @change="v => (input_name = v)"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                class="pa-0"
                :class="$mq == 'sm' ? '' : 'mr-5'"
                :cols="$mq == 'sm' ? '12' : ''"
              >
                <v-select
                  class="apply_gift_input"
                  :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-lg'"
                  solo
                  dense
                  outlined
                  :height="$mq == 'sm' ? '10vw' : 58"
                  :items="items"
                  :placeholder="$ml.get('apply_gift_sex_label')"
                  :value="input_sex"
                  :rules="[v => !!v || $ml.get('apply_gift_sex_error_1')]"
                  @change="v => (input_sex = v)"
                  required
                ></v-select>
              </v-col>
              <v-col class="pa-0" :cols="$mq == 'sm' ? '12' : ''">
                <v-text-field
                  class="apply_gift_input"
                  :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-lg'"
                  solo
                  dense
                  outlined
                  :height="$mq == 'sm' ? '10vw' : 58"
                  :placeholder="$ml.get('apply_gift_birthday_label')"
                  persistent-hint
                  :value="input_birth"
                  :rules="birthday_rules"
                  @change="v => (input_birth = v)"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              class="apply_gift_input"
              :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-lg'"
              solo
              dense
              outlined
              :height="$mq == 'sm' ? '10vw' : 58"
              :placeholder="$ml.get('counsel_login_tel_label')"
              persistent-hint
              :rules="tel_rules"
              :value="$store.state.user_info.tel"
              disabled
            ></v-text-field>

            <v-text-field
              class="apply_gift_input"
              :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-lg'"
              solo
              dense
              outlined
              readonly
              :height="$mq == 'sm' ? '10vw' : 58"
              :value="input_addr_full"
              :placeholder="$ml.get('apply_gift_addr_label')"
              :rules="address_rules"
              @click="show_addr()"
            ></v-text-field>
            <div
              class="mb-3 mt-3 apply_gift_addr_info"
              v-html="$ml.get('apply_gift_addr_info')"
            ></div>
            <KakaoMap />
            <div
              v-html="$ml.get('apply_gift_info_text')"
              class="apply_gift_info_text"
              style="text-align:left;;"
            ></div>
            <div
              v-html="$ml.get('apply_gift_info_notice')"
              class="apply_gift_info_notice"
              style="text-align:left; font-weight: bold; padding-bottom: 30px;"
            ></div>
          </v-form>
          <v-btn
            class="rounded-0 rounded-b-xl button_4"
            v-on:click="applyThanksDiary()"
          >
            {{ $ml.get("apply_gift_btn") }}
          </v-btn>
        </v-card>
      </v-row>
      <v-row v-else justify="center" class="main_root">
        <v-card
          width="100%"
          :class="$mq == 'sm' ? 'rounded-b-xl' : 'rounded-b-xl'"
          class="mainCard"
        >
          <v-row justify="center" class="mx-10 mt-10 mb-0">
            <v-img max-width="250" src="@/assets/rabbit.png"> </v-img>
          </v-row>

          <v-row justify="center" class="ma-0 pa-5 border_dash_bottom_white">
            <v-col
              cols="12"
              class="main_title_1_text"
              v-html="this.$ml.get('apply_gift_finish')"
            >
            </v-col>
          </v-row>

          <v-btn
            class="rounded-0 rounded-b-xl button_4 custom"
            v-on:click="$router.replace('/')"
          >
            {{ $ml.get("go_home_btn") }}
          </v-btn>
        </v-card>
      </v-row>
    </v-card>

    <!-- addr alert -->
    <v-dialog
      :content-class="$mq != 'sm' ? 'popup ' + $mq : 'dialog_full ' + $mq"
      v-model="alert_address"
      max-width="800"
      persistent
    >
      <v-card class="pa-5 popup_root">
        <v-btn
          elevation="0"
          class="add_img_del_btn"
          width="48"
          height="48"
          icon
          v-on:click="$router.go(-1)"
        >
        </v-btn>

        <v-card-title class="alert_title">
          <v-spacer />{{ $ml.get("apply_gift_alert_title") }}<v-spacer />
        </v-card-title>

        <v-card-text class="pa-0 my-10 d-flex flex-column alert_title_sub_info">
          <div v-show="!show_daum_postcode" @click="execDaumPostcode()">
            <v-text-field
              style="width:150px;"
              class="apply_gift_input"
              :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-xl'"
              solo
              dense
              outlined
              :height="$mq == 'sm' ? '10vw' : 58"
              :placeholder="this.$ml.get('order_kit_addr_alert_input_1')"
              :value="input_address_zipcode"
              disabled
            ></v-text-field>

            <v-text-field
              style="width:400px;"
              class="apply_gift_input"
              :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-xl'"
              solo
              dense
              outlined
              :height="$mq == 'sm' ? '10vw' : 58"
              :placeholder="this.$ml.get('order_kit_addr_alert_input_2')"
              :value="input_address"
              disabled
            ></v-text-field>
          </div>

          <v-form ref="addr_form">
            <v-text-field
              v-show="!show_daum_postcode"
              class="apply_gift_input"
              :class="$mq == 'sm' ? 'rounded-lg' : 'rounded-xl'"
              solo
              dense
              outlined
              :height="$mq == 'sm' ? '10vw' : 58"
              :placeholder="this.$ml.get('order_kit_addr_alert_input_3')"
              persistent-hint
              :value="input_address_etc"
              :rules="address_etc_rules"
              @change="v => (input_address_etc = v)"
            ></v-text-field>
          </v-form>

          <div v-show="show_daum_postcode" id="wrap" class="postcode"></div>
        </v-card-text>

        <v-btn class="mt-5 alert_btn" v-on:click="make_addr_full()">
          {{ $ml.get("alert_check_btn") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import { regexCheck } from "../common/index.js";
import KakaoMap from "../components/KakaoMap.vue";

export default {
  components: {
    KakaoMap
  },
  created() {
    var self = this;
    if (self.$store.state.user_info.kit_gubun == "N") {
      const title = self.$ml.get("apply_gift_title");
      const persistent = true;
      const info = self.$ml.get("apply_gift_alert_already_exist");
      const fn = function() {
        self.$router.replace("/");
        // self.$router.go(-1);
      };
      self.$store.commit("alert_show", {
        title,
        persistent,
        info,
        fn
      });
    }
  },

  data: function() {
    return {
      items: [
        this.$ml.get("apply_gift_sex_item_1"),
        this.$ml.get("apply_gift_sex_item_2")
      ],
      link: "http://www.sangjumind.org/sub.php?menukey=34",
      checkbox: false,
      input_name: "",
      input_birth: "",
      input_sex: "",
      show_daum_postcode: true,
      input_address: "",
      input_address_etc: "",
      input_address_zipcode: "",
      finish: false,
      alert_address: false,
      input_addr_full: "",
      name_rules: [
        value => {
          return (
            value.trim().length > 0 ||
            this.$ml.get("after_use_write_alert_error_3")
          );
        },

        value => {
          return (
            regexCheck(2, value) ||
            this.$ml.get("after_use_write_alert_error_7")
          );
        }
      ],
      birthday_rules: [
        value => {
          return (
            regexCheck(1, value) || this.$ml.get("counsel_login_tel_rules_1")
          );
        },

        value => {
          return (
            value.trim().length == 6 || this.$ml.get("counsel_birthday_check")
          );
        }
      ],
      tel_rules: [
        value => {
          return (
            regexCheck(1, value) || this.$ml.get("counsel_login_tel_rules_1")
          );
        },
        value =>
          (value || "").length == 11 ||
          this.$ml.get("counsel_login_tel_rules_2")
      ],
      address_rules: [
        value =>
          (value || "").length != "" || this.$ml.get("thanksdiary_addr_rules")
      ],
      address_etc_rules: [
        value =>
          (value || "").length != "" ||
          this.$ml.get("thanksdiary_addr_etc_rules_1")
      ]
    };
  },
  computed: {
    title() {
      return this.$mq == "sm"
        ? this.$ml.get("apply_gift_title_info_sub_title_m")
        : this.$ml.get("apply_gift_title_info_sub_title");
    }
  },
  methods: {
    show_addr: function() {
      var target = this.$route.fullPath.substring(
        this.$route.fullPath.indexOf("#")
      );
      //#alert_address가
      // 있는 상태이면 팝업만 띄움
      if (target == "#alert_address") {
        this.alert_address = true;

        var self = this;
        setTimeout(function() {
          self.execDaumPostcode();
        }, 300);
      }
      //아니면 push
      else {
        this.$router.push({ hash: "#alert_address" });
      }
    },

    applyThanksDiary() {
      if (this.$refs.form != null && !this.$refs.form.validate()) {
        return;
      } else {
        //api_kit_add
        var self = this;
        var api = "api_kit_add.php";
        var param = {
          name: encodeURI(this.input_name),
          sex: encodeURI(this.input_sex),
          tel: encodeURI(this.$store.state.user_info.tel),
          birthday: encodeURI(this.input_birth),
          address: encodeURI(this.input_addr_full)
        };

        self.$store.dispatch("apiCall", { api, param }).then(() => {
          var data = self.$store.state.api_result;
          // console.log(data);
          if (data == false || data == "err") {
            //error
            alert(
              "정보를 가져오는데 실패하였습니다. 새로 고침 후 다시 시도해 주세요."
            );
          } else {
            try {
              if (data.ret_code == "S") {
                //사용자 정보 업데이트
                self.$store.dispatch("loginGubun");
                self.finish = true;
              } else if (data.ret_code == "I") {
                const title = this.$ml.get("after_send_alert_fail_title");
                const info = data.ret_msg;
                this.$store.commit("alert_show", { title, info });
                return;
              } else if (data.ret_code == "FS") {
                const title = this.$ml.get("after_send_alert_fail_title");
                const info = data.ret_msg;
                this.$store.commit("alert_show", { title, info });
                return;
              }
            } catch (e) {
              alert(
                "정보를 가져오는데 실패하였습니다. 새로 고침 후 다시 시도해 주세요."
              );
            }
          }
        });
      }
    },

    execDaumPostcode() {
      var self = this;
      var element_wrap = document.getElementById("wrap");
      self.show_daum_postcode = true;

      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete: function(data) {
          // console.log(data);
          // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          var addr = ""; // 주소 변수

          //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === "R") {
            // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else {
            // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          self.input_address_zipcode = data.zonecode;
          self.input_address = addr;

          //주소 보여주기
          self.show_daum_postcode = false;
        },
        // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
        onresize: function() {
          // element_wrap.style.height = size.height+'px';
        },
        width: "100%",
        height: "100%",
        submitMode: false
      }).embed(element_wrap, { autoClose: true });
    },

    make_addr_full: function() {
      if (!this.$refs.addr_form.validate()) {
        return;
      } else {
        var self = this;
        self.input_addr_full = `(${self.input_address_zipcode}) ${self.input_address} ${self.input_address_etc}`;
        self.$router.go(-1);
      }
    },

    openURL() {
      window.open(
        this.link,
        "새창",
        "width=1500, height=1000, toolbar=no, menubar=no, scrollbars=no, resizable=yes"
      );
    },

    openURL_m() {
      // window.open(this.link, "네이버새창", "width=100%, height=100%, toolbar=no, menubar=no, scrollbars=no, resizable=yes" );
    }
  },
  watch: {
    $route(to) {
      //팝업 띄움
      var target = to.fullPath.substring(to.fullPath.indexOf("#"));

      if (target === "#alert_address") {
        this.alert_address = true;

        var self = this;
        setTimeout(function() {
          self.execDaumPostcode();
        }, 300);
      } else if (target.indexOf("#") < 0) {
        this.alert_address = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/common";
.bg_card {
  background-image: url("../assets/bg_healing.png");
}

.mainCard {
  background-color: $bg-color-contents-tanksdiary;
  border: solid 2px $ft-color-title-white;
  border-radius: 0px;
}

.title_text_sub {
  display: flex;
  justify-content: center;
  font: normal normal normal 20px/30px Noto;
  height: 30px;
  letter-spacing: 0px;
  color: $ft-color-title-black;
}

.title_text_sub .star {
  height: 24px;
  max-width: 24px;
  margin-right: 4px;
}

.font_black {
  color: $ft-color-title-black !important;
}

.font_white {
  color: $ft-color-title-white !important;
}

.border_dash_bottom {
  background-color: $bg-color-counsel_write-textarea;
  border-bottom: dashed 2px $bg-color-counsel_write-border;
}

.apply_gift_input_root {
  padding: 0px 70px;
  background-color: $bg-color-apply-gift-input-root;
}

.apply_gift_input {
  font: normal normal normal 18px/24px Noto !important;
  letter-spacing: 0px;
}

.checkBoxPosition {
  display: flex;
  flex-direction: row;
}

.open_url {
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-left: 6px;
  height: 100%;
  min-height: 24px;
  font-size: 18px;
  line-height: 30px;
  // margin-left: 5px;
  // width: 100px !important;
}

.url_position {
  display: inline-block;
  width: 100% !important;
  // width: 76px !important;
  cursor: pointer;
}

.border_dash_bottom_white {
  border-bottom: solid 1px $ft-color-title-white;
}

.button_4.custom {
  background-color: $bg-color-btn-4-custom !important;
  border-top: solid 1px $ft-color-title-white;
}

.button_4.custom:hover {
  background-color: $bg-color-btn-4-custom-over !important;
}

/* alert */
.add_img_del_btn {
  position: absolute;
  top: 0px;
  right: 0px;
  margin: 20px;
  background-image: url("../assets/image_cancle_button_x.png");
  background-size: contain;
}

.postcode {
  border: 1px solid;
  width: 100%;
  height: calc(90vh - 450px);
  min-height: 200px;
  margin: 0px;
  position: relative;
}

.apply_gift_info_text {
  text-align: left;
  font-size: 20px;
}

.apply_gift_addr_info {
  font-size: 20px;
  text-align: center;
}

.apply_gift_info_notice {
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  padding-bottom: 30px;
}

/* mobile */
.sm.bg_card {
  background-image: url("../assets/bg_healing_m.png");

  .title_text_sub {
    font: normal normal normal 4vw/6vw Noto !important;
    height: 6vw;
    margin-top: 1vw;
  }

  .title_text_sub .star {
    height: 5vw;
    max-width: 5vw;
  }

  .apply_gift_input_root {
    padding: 0px 3vw;
  }

  .apply_gift_input {
    font: normal normal normal 3.2vw/5vw Noto !important;
  }

  .open_url {
    font: normal normal normal 3.2vw/5vw Noto !important;
  }

  .url_position {
    width: 20vw !important;
  }

  .main_title_1_text {
    padding-bottom: 1vw;
    letter-spacing: 0px;
  }

  .apply_gift_info_text {
    text-align: left;
    font-size: 3vw;
  }

  .apply_gift_addr_info {
    font-size: 3vw;
  }

  .apply_gift_info_notice {
    text-align: left;
    font-weight: bold;
    font-size: 3vw;
    padding-bottom: 30px;
  }
}

.sm {
  .postcode {
    height: calc(78vh - 240px);
  }
}
</style>
